import React from 'react';
import Popup from './Popup';

type SigningWhatsappInfoPopupProps = {
    onClose: () => void;
};

export const SigningWhatsappInfoPopup: React.FC<SigningWhatsappInfoPopupProps> = ({ onClose }) => (
    <Popup onClose={onClose}>
        <div className="security-info-popup">
            <h3 className="H3_21">Код подтверждения при подписании</h3>

            <div className="security-section">
                <h4 className="Subheader_17">Что используется по умолчанию</h4>
                <p>
                    При подписании документов подписанту предлагаются способы получения кода подтверждения:
                </p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', marginTop: '10px' }}>
                    <li>входящий звонок — код содержится в номере звонящего</li>
                    <li>мессенджер Telegram</li>
                    <li>мессенджер MAX</li>
                </ul>
            </div>

            <div className="security-section">
                <h4 className="Subheader_17">Подключение WhatsApp</h4>
                <p>
                    Дополнительно можно подключить отправку кода в WhatsApp. После подключения опции
                    подписант сможет получить код в сообщении в WhatsApp на указанный номер телефона.
                </p>
                <p>
                    Удобно, если подписант за рубежом или SMS на его номер недоступны.
                    Звонок, Telegram и MAX остаются запасными способами.
                </p>
                <p>
                    Опция применяется к новым договорам, созданным после её подключения.
                </p>
            </div>
        </div>
    </Popup>
);
